import { css } from '@emotion/css';
import { theme } from 'antd';
import { useMemo } from 'react';

export const useBefundeListStyles = () => {
  const { token } = theme.useToken();

  return useMemo(
    () => ({
      layout: css`
        height: 100%;
        width: 100%;
        padding-bottom: ${token.paddingLG}px;

        @media (min-width: ${token.screenLG}px) {
          min-width: 300px;
          width: 300px;
        }

        @media (min-width: ${token.screenXL}px) {
          min-width: 350px;
          width: 350px;
        }

        @media (min-width: ${token.screenXXL}px) {
          min-width: 400px;
          width: 400px;
        }
      `,
      befundListWrapper: css`
        height: 100%;
        overflow-y: auto;
        width: 100%;
        border-right: 1px solid ${token.colorBorder};
        padding-right: ${token.paddingXS}px;

        @media (max-width: ${token.screenLG}px) {
          border-right: none;
          padding-right: 0;
        }
      `,
      reloadSection: css`
        display: flex;
        align-items: center;
        width: 100%;
        height: 40px;
      `,
      reloadButton: css`
        width: 100%;
      `,
    }),
    [token]
  );
};
